import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=01ac3428&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=js&"
export * from "./JobDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=01ac3428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac3428",
  null
  
)

export default component.exports